export const COPY_TRIGGER = 'COPY_TRIGGER';
export const COPY_SUCCESS = 'COPY_SUCCESS';

export const triggerCopy = () => ({
  type: COPY_TRIGGER,
});

export const successCopy = () => ({
  type: COPY_SUCCESS,
});
